import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DominioDto } from '../../../dto/justino/dominio.dto';
import { DominioService } from '../../../services/dominio.service';
import { ModalNomDesComponent } from '../modal-nom-des/modal-nom-des.component';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import { FileUploadService } from '../../../services/file-upload.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DatasetDto } from '../../../dto/justino/dataset.dto';
import test from 'node:test';

@Component({
  selector: 'app-dominios',
  templateUrl: './dominios.component.html',
  styleUrl: './dominios.component.scss',
})
export class DominiosComponent implements OnInit {
  // Define el id del dominio
  idDominio!: string;
  // Track the current page
  currentPage: number = 1;
  // Track the search term
  searchTerm: string = '';
  // Define la lista de dominios
  dominios: DominioDto[] = [];
  // Define la lista de subdominios
  subDominios: DominioDto[] = [];
  // Define la lista de subdominios del sistema
  subDominiosSistema: DominioDto[] = [];
  // Define el mensaje sin datos
  mensaje: string = 'No hay datos disponibles.';
  // Define el flag del modal
  modalNDFlag: boolean = false;
  // Define el flag de la lista
  listFlag: boolean = true;
  // Define el flag de lectura
  readFlag: boolean = false;
  // Define el flag de subdominio
  subDominioFlag: boolean = false;
  // Define el dominio
  dominio!: DominioDto;
  // Define el dataset del dominio
  dataset: DatasetDto | undefined;
  // Define bandera de indexado
  indexadoFlag: boolean = false;
  // Define bandera de indexado
  editableDatasetFlag: boolean = true;
  // Define bandera si es binario
  isBinaryFlag: boolean = false;
  // Define el formulario de dominio
  dominioForm!: FormGroup;
  // Define si el formulario es de solo lectura
  isReadOnly: boolean = true;
  // Define los campos del formulario
  nomDesForm: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El nombre es requerido',
        pattern:
          'Solo se permiten letras, números y guiones (-). Ejemplo: nombre-1, dos-nombres',
      },
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      required: true,
      width: '12',
      visible: true,
    },
    {
      name: 'estado',
      label: 'Estado',
      type: 'select',
      required: false,
      width: '6',
      visible: true,
      errorMessages: { required: 'El estado es obligatorio' },
    },
    {
      name: 'indexado',
      label: 'Indexado',
      type: 'checkbox',
      required: false,
      width: '6',
      visible: true,
    },
  ];
  // Define los estados
  estados = ['Activo', 'Inactivo'];
  // Define el formulario de subdominio
  @ViewChild(ModalNomDesComponent)
  modalND!: ModalNomDesComponent;
  // Define si se está arrastrando un archivo
  isDragging = false;

  // Define el formulario de subida de video
  videoForm: FormGroup = new FormGroup({
    videoUrl: new FormControl(null, [Validators.required]),
  });

  // Define el formulario de dataset
  datasetform: FormGroup = new FormGroup({
    Contenido: new FormControl(null, [Validators.required]),
  });

  // Define la configuración de Quill
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
  };

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private fileUploadService: FileUploadService,
    private spinnerService: SpinnerService,
    private dominioService: DominioService,
    private alertService: AlertaModalService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.idDominio = params.get('idDominio') || '';
      console.log('ID Dominio:', this.idDominio);
      if (this.idDominio == 'base') {
        this.subDominioFlag = false;
        this.loadDominios();
      } else {
        this.dominioService.getDominioById(this.idDominio).subscribe({
          next: data => {
            this.dominio = data;
            this.subDominioFlag = true;
            this.loadSubDominios();
          },
          error: err => {
            this.alertService.error(
              `Error al cargar el subdominio: ${err.statusText}`
            );
          },
        });
      }
      this.listFlag = true;
      this.readFlag = false;
    });
    this.createForm();
  }

  loadSubDominios(): void {
    this.dominioService.getSubdominiosById(this.dominio.Id).subscribe({
      next: data => {
        this.dominios = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los dominios: ${err.statusText}`
        );
      },
    });
  }

  loadDominios(): void {
    this.dominioService.getDominios().subscribe({
      next: data => {
        this.dominios = data;
        this.dominios = this.dominios.filter(d => d.ParentId == '0');
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los dominios: ${err.statusText}`
        );
      },
    });
  }

  editarDominio(dominio: DominioDto) {
    this.dominio = dominio;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = false;
    this.isBinaryFlag = false;
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.dominioForm.disable();
    } else {
      this.dominioForm.enable();
    }
    if (this.dominio.DataSet) {
      this.getDatasetDominio();
    }
    this.dominioService.getSubdominiosById(this.dominio.Id).subscribe({
      next: data => {
        this.subDominios = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los subdominios: ${err.statusText}`
        );
      },
    });
  }

  eliminarDominio(id: string) {
    this.alertService.confirmacion(
      '¿Desea eliminar el dominio?',
      'Eliminar',
      () => {
        this.dominioService.deleteDominio(id).subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Dominio eliminado correctamente'
            );
            this.loadDominios();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al eliminar el dominio: ${err.statusText}`
            );
          },
        });
      },
      () => {}
    );
  }

  registrarDominio(dto: any) {
    const nuevoNombre = dto.nombre;
    const nuevoDescripcion = dto.descripcion;
    this.modalND.abrirCerrarModal();
    if (nuevoNombre && nuevoNombre.trim() !== '') {
      const nuevoDominio: DominioDto = {
        Id: '0',
        ParentId: '0',
        Nombre: nuevoNombre,
        Descripcion: nuevoDescripcion,
        Estado: 'Activo',
        FechaCreacion: new Date().toISOString(),
        FechaModificacion: new Date().toISOString(),
        UsuarioCreacion: 'admin',
        UsuarioModificacion: 'admin',
        SubDominios: [],
      };
      if (this.subDominioFlag) {
        nuevoDominio.ParentId = this.dominio.Id;
        this.dominioService.createSubdominio(nuevoDominio).subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Subdomino creado correctamente'
            );
            this.loadDominios();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al crear el subdominio: ${err.statusText}`
            );
          },
        });
      } else {
        this.dominioService.createDominio(nuevoDominio).subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Dominio creado correctamente'
            );
            this.loadDominios();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al crear el dominio ${err.statusText}`
            );
          },
        });
      }
    }
  }

  async crearDominio() {
    this.abrirModalND();
  }

  abrirModalND() {
    this.modalNDFlag = true;
    setTimeout(() => {
      this.modalND.abrirCerrarModal();
    }, 500);
  }

  onRowClick(dominio: DominioDto) {
    this.dominio = dominio;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = this.readFlag;
    this.isBinaryFlag = false;
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.dominioForm.disable();
    } else {
      this.dominioForm.enable();
    }
    if (this.dominio.DataSet) {
      this.getDatasetDominio();
    }
    this.dominioService.getSubdominiosById(this.dominio.Id).subscribe({
      next: data => {
        this.subDominios = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los subdominios: ${err.statusText}`
        );
      },
    });
  }

  volverElemento() {
    this.listFlag = true;
    this.readFlag = false;
    this.isReadOnly = this.readFlag;
    this.dominioForm.reset();
  }

  createForm(): void {
    const formControls: any = {};
    this.nomDesForm.forEach(field => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      if (field.name === 'nombre') {
        validators.push(Validators.pattern(/^[a-zA-Z0-9-]+$/));
      }
      formControls[field.name] = [null, validators];
    });
    this.dominioForm = this.fb.group(formControls);
    if (this.isReadOnly) {
      this.dominioForm.disable();
    }
  }

  fillFormWithData(): void {
    if (this.dominio) {
      this.dominioForm.patchValue({
        nombre: this.dominio.Nombre,
        descripcion: this.dominio.Descripcion,
        estado: this.dominio.Estado,
        indexado: this.dominio.Indexado,
      });
      this.indexadoFlag = this.dominio.Indexado ? true : false;
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.dominioForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.nomDesForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  toggleEdit(): void {
    this.isReadOnly = !this.isReadOnly;
    if (this.isReadOnly) {
      this.dominioForm.disable();
    } else {
      this.dominioForm.enable();
    }
  }

  isNameUnique(name: string): boolean {
    return !this.dominios.some(
      el => el.Nombre.toLowerCase() === name.toLowerCase()
    );
  }

  submitForm(): void {
    if (this.dominioForm.valid) {
      const dto = this.dominioForm.value;
      if (this.dominio.Nombre != dto.nombre) {
        if (!this.isNameUnique(dto.nombre)) {
          this.alertService.error(
            'Error al actualizar el dominio',
            'El nombre ya existe'
          );
          return;
        }
      }
      this.dominio.Nombre = dto.nombre;
      this.dominio.Descripcion = dto.descripcion;
      this.dominio.Estado = dto.estado;
      this.dominio.Indexado = dto.indexado;
      this.dominioService
        .updateDominio(this.dominio.Id, this.dominio)
        .subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Dominio actualizado correctamente'
            );
            this.loadDominios();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al actaulizar el dominio: ${err.statusText}`
            );
          },
        });
      this.isReadOnly = true;
      this.dominioForm.disable();
    } else {
      this.dominioForm.markAllAsTouched();
    }
  }

  eliminarSubDominio(idSubDominio: string) {
    this.dominio.SubDominios = this.dominio.SubDominios.filter(
      d => d !== idSubDominio
    );
    this.dominioService.updateDominio(this.dominio.Id, this.dominio).subscribe({
      next: () => {
        this.spinnerService.hideSpinner();
        this.alertService.exito(
          'Mensaje informativo',
          'Dominio actualizado correctamente'
        );
        this.loadDominios();
      },
      error: err => {
        this.spinnerService.hideSpinner();
        this.alertService.error(
          `Error al actaulizar el dominio: ${err.statusText}`
        );
      },
    });
  }

  editarSubDominios() {
    this.loadSubDominios();
    this.listFlag = true;
    this.readFlag = false;
    this.subDominioFlag = true;
  }

  volverPadre() {
    if (this.idDominio == 'base') {
      this.loadDominios();
      this.subDominioFlag = false;
    } else {
      this.loadSubDominios();
      this.subDominioFlag = true;
    }
    this.listFlag = true;
    this.readFlag = false;
  }

  verSubDominio(idSubDominio: string) {}

  // Método que se ejecuta al cargar un archivo
  // Parámetros:
  // file: any - Archivo a cargar
  // idEntidad: number - Identificador de la entidad
  // fileName: string - Nombre del archivo
  uploadProcess(file: any, idDominio: string) {
    this.fileUploadService
      .fileToBase64(file)
      .then(base64 => {
        this.fileUploadService
          .uploadDomainFile(base64, idDominio)
          .pipe(
            catchError(error => {
              this.spinnerService.hideSpinner();
              if (error.status === 404) {
                this.alertService.error(
                  'Servicio no disponible, por favor intente nuevamente más tarde'
                );
              } else if (error.status === 400) {
                if (error.error) {
                  this.alertService.error(error.error);
                } else {
                  this.alertService.error('Error al cargar el archivo');
                }
              } else if (error.status > 500) {
                if (error.error) {
                  this.alertService.error(
                    `Error al cargar el archivo ${error.error}`
                  );
                } else {
                  this.alertService.error('Error al cargar el archivo');
                }
              } else {
                this.alertService.error('Error al cargar el archivo');
              }
              return of({ data: [] });
            })
          )
          .subscribe(response => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Archivo cargado correctamente'
            );
            const data: any = response;
            this.dominio.DataSet = data.Id;
            this.getDatasetDominio();
          });
      })
      .catch(error => {
        console.error('Error converting file to Base64:', error.error);
      });
  }

  // Método que se ejecuta al seleccionar un archivo
  // Parámetros:
  // event: Event - Evento de selección
  // Retorna un Observable de tipo void
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      
      // Validar tipo de archivo
      if (!this.checkIfFileIsValid(file)) {
        this.alertService.error('El archivo debe ser de tipo texto (.txt) o PDF (.pdf)');
        input.value = '';
        return;
      }
      
      // Validar tamaño del archivo
      if (!this.checkFileSize(file)) {
        this.alertService.error('El archivo no debe superar los 10MB');
        input.value = '';
        return;
      }
      
      input.value = '';
      this.uploadProcess(file, this.dominio.Id);
    }
  }

  // Método que se ejecuta al arrastrar un archivo
  // Parámetros:
  // event: DragEvent - Evento de arrastre
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  // Método que se ejecuta al salir del arrastre
  // Parámetros:
  // event: DragEvent - Evento de arrastre
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  // Método que valida si el archivo es un .txt o .pdf
  // Parámetros:
  // file: File - archivo
  checkIfFileIsValid(file: File): boolean {
    const validMimeTypes = ['text/plain', 'application/pdf'];
    return validMimeTypes.includes(file.type);
  }

  // Método que valida el tamaño del archivo (máximo 10MB)
  // Parámetros:
  // file: File - archivo
  checkFileSize(file: File): boolean {
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB en bytes
    return file.size <= maxSizeInBytes;
  }

  // Método que se ejecuta al soltar un archivo
  // Parámetros:
  // event: DragEvent - Evento de arrastre
  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      
      // Validar tipo de archivo
      if (!this.checkIfFileIsValid(file)) {
        this.alertService.error('El archivo debe ser de tipo texto (.txt) o PDF (.pdf)');
        return;
      }
      
      // Validar tamaño del archivo
      if (!this.checkFileSize(file)) {
        this.alertService.error('El archivo no debe superar los 10MB');
        return;
      }
      
      this.uploadProcess(file, this.dominio.Id);
    }
  }

  submitVideoForm(): void {
    if (this.videoForm.valid) {
      const dominioDto = this.videoForm.value;
      this.dominio.videoUrl = dominioDto.videoUrl;
      this.dominioService
        .sendVideoProcessRequest(this.dominio, true)
        .subscribe({
          next: data => {
            this.dataset = data;
            if (this.dataset) {
              this.dominio.DataSet = this.dataset.Id;
              this.datasetform.patchValue({
                Contenido: this.decodeBase64UTF8(this.dataset.Contenido),
              });
            }
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Solicitud de procesamiento de video enviada correctamente'
            );
          },
          error: err => {
            this.spinnerService.hideSpinner();
            if (err.status === 400) {
              this.alertService.error('El archivo no es un video o excede el tamaño permitido');
            } else {
              this.alertService.error(
                `Error al enviar la solicitud de procesamiento de video: ${err.statusText}`
              );
            }
          },
        });
    }
  }

  getDatasetDominio(): void {
    if (this.dominio.videoUrl) {
      this.videoForm.patchValue({
        videoUrl: this.dominio.videoUrl,
      });
    }
    this.dominioService.getDataSetContent(this.dominio.DataSet!).subscribe({
      next: data => {
        this.spinnerService.hideSpinner();
        this.dataset = data;
        let text = this.decodeBase64UTF8(this.dataset.Contenido);
        if (text && text.length > 20000) {
          text = text.substring(0, 20000) + '...';
          this.editableDatasetFlag = false;
          this.isBinaryFlag = true;
        } else {
          this.isBinaryFlag = false;
          this.editableDatasetFlag = true;
        }
        this.datasetform.patchValue({
          Contenido: text,
        });
      },
      error: err => {
        this.spinnerService.hideSpinner();
        this.alertService.error(
          `Error al obtener el dataset del dominio: ${err.statusText}`
        );
      },
    });
  }

  decodeBase64UTF8(base64: string): string {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  }

  encodeBase64UTF8(input: string): string {
    const utf8Bytes = new TextEncoder().encode(input);
    const binaryString = utf8Bytes.reduce(
      (data, byte) => data + String.fromCharCode(byte),
      ''
    );
    return btoa(binaryString);
  }

  editarContenidoDataset(): void {
    const contenido = this.encodeBase64UTF8(
      this.datasetform.get('Contenido')?.value
    );
    if (this.datasetform.valid) {
      if (this.dataset) {
        this.dataset.Contenido = contenido;
        this.dominioService
          .updateContenidoDatasetDominio(this.dataset)
          .subscribe({
            next: () => {
              this.spinnerService.hideSpinner();
              this.alertService.exito(
                'Mensaje informativo',
                'Contenido del dataset actualizado correctamente'
              );
              this.getDatasetDominio();
            },
            error: err => {
              this.spinnerService.hideSpinner();
              this.alertService.error(
                `Error al actualizar el contenido del dataset: ${err.statusText}`
              );
            },
          });
      }
    }
  }

  eliminarDataset() {
    this.alertService.confirmacion(
      '¿Desea eliminar el dataset?',
      'Eliminar',
      () => {
        const dominioId = this.dominio.Id;
        if (this.dataset) {
          const datasetId = this.dataset.Id;
          this.dominioService.deleteDataSet(datasetId, dominioId).subscribe({
            next: () => {
              this.spinnerService.hideSpinner();
              this.alertService.exito(
                'Mensaje informativo',
                'Dataset eliminado correctamente'
              );
              this.loadDominios();
              this.dominio.DataSet = undefined;
              this.dataset = undefined;
            },
            error: err => {
              this.spinnerService.hideSpinner();
              this.alertService.error(
                `Error al eliminar el dataset: ${err.statusText}`
              );
            },
          });
        }
      },
      () => {}
    );
  }
}
